var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready)?_c('ChiefSupervisorReportManagerWrapper',{attrs:{"supervisors":_vm.supervisors,"workers":_vm.workers}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }